import React from 'react';

const SVG = ({ style = {}, color = 'rgb(255, 68, 68)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <rect x="33" y="33" width="36" height="36" fill={color} />
    </g>
  </svg>
);

export default SVG;
